import React from 'react';
import { NavLink } from 'react-router-dom';

import { useAppSelector } from '../../store/hooks';
import {
  selectFloorPlanConfirmedCount,
  selectFloorPlanPendingCount,
} from '../../store/selectors/floorPlanBadges';
import { selectPendingInvitesCount } from '../../store/selectors/pendingInvites';

type NavItem = {
  to: string;
  label: string;
  icon: string;
};

const items: NavItem[] = [
  { to: '/floor-plan', label: 'План', icon: '🗺️' },
  { to: '/events', label: 'События', icon: '📜' },
  { to: '/games', label: 'Игры', icon: '🎲' },
  { to: '/groups', label: 'Группы', icon: '🏰' },
  { to: '/users', label: 'Люди', icon: '👥' },
  { to: '/profile', label: 'Профиль', icon: '👤' },
];

const formatBadge = (count: number): string | null =>
  count <= 0 ? null : count > 9 ? '9+' : String(count);

export function BottomNav({ disabled = false }: { disabled?: boolean }) {
  const pendingInvitesCount = useAppSelector(selectPendingInvitesCount);
  const floorPlanConfirmed = useAppSelector(selectFloorPlanConfirmedCount);
  const floorPlanPending = useAppSelector(selectFloorPlanPendingCount);

  const pendingBadgeText = formatBadge(pendingInvitesCount);
  const confirmedBadgeText = formatBadge(floorPlanConfirmed);
  const floorPlanPendingText = formatBadge(floorPlanPending);

  return (
    <nav className={['ttbBottomNav', disabled ? 'ttbBottomNavDisabled' : null].filter(Boolean).join(' ')}>
      <div className="ttbBottomNavGrid">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={disabled ? '/' : item.to}
            onClick={(e) => {
              if (disabled) e.preventDefault();
            }}
            className={({ isActive }) =>
              [
                'ttbBottomNavLink',
                isActive && !disabled ? 'ttbBottomNavLinkActive' : null,
                disabled ? 'ttbBottomNavLinkDisabled' : null,
              ]
                .filter(Boolean)
                .join(' ')
            }
          >
            <span className="ttbBottomNavIcon">{item.icon}</span>
            <span className="ttbBottomNavLabel">
              {item.label}
              {item.to === '/floor-plan' && (confirmedBadgeText || floorPlanPendingText) ? (
                <span className="ttbBottomNavBadgeGroup">
                  {confirmedBadgeText && (
                    <span className="ttbBottomNavBadge ttbBottomNavBadge--success">
                      {confirmedBadgeText}
                    </span>
                  )}
                  {floorPlanPendingText && (
                    <span className="ttbBottomNavBadge ttbBottomNavBadge--warning">
                      {floorPlanPendingText}
                    </span>
                  )}
                </span>
              ) : null}       
            </span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
